import { MoreVertOutlined } from "@mui/icons-material";
import { Menu, Stack, Box } from "@mui/material";
import React, { useState, useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationsMenu from "../../components/Common/NotificationMenu/index.jsx";
import { useQuickLinksItems } from "../../context/QuickLinksContext";
import { useScrollHeader } from "./useScrollHeader";
import {
  RootWrapper,
  HeaderPlaceholder,
  MenuIconButton,
  LogoImgSmall,
  LogoImgFull,
  RightSectionStack,
  AvatarBox,
  UserInfoStack,
  UserNameText,
  UserRoleText,
  MoreMenuIconButton,
  StyledMenuItem,
  LogoImg,
} from "./Navbar.styles";

const Navbar = ({ setThemeChange, setOpenSidebar }) => {
  const navigate = useNavigate();
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  const { isAtTop, isVisible } = useScrollHeader(10);

  useLayoutEffect(() => {
    const el = headerRef.current;
    if (!el) return;

    const updateHeight = () => setHeaderHeight(el.getBoundingClientRect().height);
    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const { userData, iphcPractitioner } = useSelector((state) => state.user);
  const { setSelectedTab } = useQuickLinksItems();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const logoSmall = require("../../assets/images/logo_lg.png");
  const logoFull = require("../../assets/images/full_logo.png");

  const displayRole =
    userData?.role === "patient"
      ? "Nirva Client"
      : iphcPractitioner && Object.keys(iphcPractitioner).length > 0
      ? "Nirva Practitioner"
      : userData?.role;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    navigate("/login");
    localStorage.removeItem("quickLinksItems");
    localStorage.removeItem("allTabs");
    localStorage.removeItem("selectedTab");
    localStorage.removeItem("token");
  };

  return (
    <>
      <HeaderPlaceholder height={headerHeight} />
      <RootWrapper
        ref={headerRef}
        isVisible={isVisible}
        isAtTop={isAtTop}
      >
      <Box sx={{ display: "flex", gap: "10px", marginLeft: { xs: 0, md: "30px" } }}>
        <MenuIconButton onClick={() => setOpenSidebar(true)}>
          <LogoImg />
        </MenuIconButton>
        <LogoImgSmall
          src={logoSmall}
          alt="logo"
          onClick={() => { navigate("/home"); setSelectedTab("home"); }}
        />
        <LogoImgFull
          src={logoFull}
          alt="logo"
          onClick={() => { navigate("/home"); setSelectedTab("home"); }}
        />
      </Box>

      <RightSectionStack>
        <Box sx={{ alignItems: "center", display: "flex", gap: 1 }}>
          <NotificationsMenu />

          {/* The logic for changing the app's background color is temporarily hidden. If today is October 2026, you can safely remove all related logic */}
          {/* <SettingseIconButton onClick={() => setThemeChange(true)}>
            <Settings />
          </SettingseIconButton> */}
        </Box>

        <Stack direction="row" spacing={2} alignItems="center">
          <AvatarBox>
            {userData?.firstName?.charAt(0) || "—"}
          </AvatarBox>
          <UserInfoStack direction="column">
            <UserNameText>
              {userData?.firstName != null && userData?.lastName != null
                ? `${userData.firstName} ${userData.lastName}`
                : "…"}
            </UserNameText>
            <UserRoleText>{displayRole ?? "…"}</UserRoleText>
          </UserInfoStack>
        </Stack>
        <MoreMenuIconButton onClick={handleClick}>
          <MoreVertOutlined />
        </MoreMenuIconButton>
      </RightSectionStack>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <StyledMenuItem
          onClick={() => {
            handleClose();
            navigate("/settings");
          }}
        >
          Settings
        </StyledMenuItem>
        <StyledMenuItem onClick={handleLogout} sx={{ color: "#d32f2f" }}>
          Log Out
        </StyledMenuItem>
      </Menu>
    </RootWrapper>
    </>
  );
};

export default Navbar;
